/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { Component } from 'react'

import type { UpdatedTlsChain } from '@modules/cloud-api/v1/types'
import type { AsyncRequestState, License, RegionId } from '@modules/ui-types'
import { CuiAlert } from '@modules/cui/Alert'

import schedule from '../../lib/schedule'

import PlatformHealthProblems from './PlatformHealthProblems'

import type { ReactNode } from 'react'

type Props = {
  children?: ReactNode
  fetchLicense: (regionId: string) => void
  fetchLicenseRequest: AsyncRequestState
  fetchRegion: () => void
  license?: License | null
  regionId: string
  providersRequest: AsyncRequestState
  fetchTlsCertificate: (regionId: RegionId, target: UpdatedTlsChain) => void
}

class Region extends Component<Props> {
  componentDidMount() {
    const { fetchLicense, regionId } = this.props

    fetchLicense(regionId)
  }

  render() {
    const { providersRequest, regionId, children } = this.props

    if (providersRequest.error) {
      return <CuiAlert type='error'>{providersRequest.error}</CuiAlert>
    }

    return (
      <section>
        <PlatformHealthProblems regionId={regionId} spacerAfter={true} />

        {children}
      </section>
    )
  }
}

export default schedule(
  Region,
  ({ fetchRegion, fetchTlsCertificate, regionId }) => {
    fetchRegion()
    fetchTlsCertificate(regionId, { service: 'ui' })
    fetchTlsCertificate(regionId, { service: 'proxy' })
    fetchTlsCertificate(regionId, { service: 'internalca' })
    fetchTlsCertificate(regionId, { service: 'adminconsole' })
  },
  [`regionId`],
)
